export var AppBarFlyoutLinkID = {
    appgallery: '05720909-E0DF-4988-9767-6C80FC244085',
    store: '6EC82A67-7012-4F21-A8C4-1DF64B310923',
};
//# sourceMappingURL=AppBarFlyoutLinkID.js.map